<nav class="navbar navbar-default" role="navigation">
  <div class="navbar-header">
    <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target=".main-menu" aria-expanded="false" aria-controls="navbar"> <span class="sr-only">Navegação</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="main-menu collapse navbar-collapse">
          <ul id="irmenu" class="nav navbar-nav">
            <li pmv-nav-item *ngFor="let item of navItems" [item]="item"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</nav>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbl.html